import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SiteLayout } from "../components/site/SiteLayout";
import { SEO } from "../components/site/SEO";

export default function NotFound() {
  return (
    <SiteLayout>
      <SEO title="Page not found — Fourbees Consultancy" path="/404" />
      <section className="bg-cream py-28 md:py-40" data-testid="not-found-page">
        <div className="container-site">
          <div className="section-number mb-3">— 404</div>
          <h1 className="font-heading text-5xl md:text-7xl font-extrabold text-navy leading-[1.0] tracking-tight mb-6">
            Page not found.
          </h1>
          <p className="font-body text-charcoal/70 max-w-xl leading-relaxed mb-10">
            The page you were looking for isn't here. It may have moved, or the link
            might not be quite right.
          </p>
          <Link to="/" className="btn-primary" data-testid="not-found-home">
            <ArrowLeft size={16} strokeWidth={2.5} />
            Back to the home page
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}
